<template>
    <div>
        <div class="card-content">
            <div class="row">
                <div class="col-10">
                    <b-form-input id="name-input"
                                  class="o-form"
                                  type="text"
                                  v-model="localText"
                                  required
                                  :placeholder="localPlaceholder"
                                  @blur.native="leftInput">
                    </b-form-input>
                </div>
                <div class="col-2">
                    <a href="javascript:void(0)" @click="deleteClicked"><icon name="trash-o"></icon></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex'
    import {
        MUSIC_ACTION_DELETE_MUSIC,
        MUSIC_ACTION_UPDATE_MUSIC,
        MUSIC_ACTION_CREATE_MUSIC,
        MUSIC_GETTER_MUSIC_BY_ID,
        MUSIC_MUTATION_SINGLE_MUSIC_ATTRIBUTE,
        MUSIC_TYPE_CEREMONY_MUSICS,
        MUSIC_TYPE_CEREMONY_BANDS,
        MUSIC_TYPE_OBSERVANCE_MUSICS,
        MUSIC_TYPE_OBSERVANCE_BANDS,
        MUSIC_NAMESPACE
    } from '../../../store/modules/music-types'
    import 'vue-awesome/icons/trash-o'
    import Icon from 'vue-awesome/components/Icon'
    import i18n from '../../../assets/i18n/lang'

    export default {
        name: 'Music',
        components: {
            'icon': Icon
        },
        props: ['musicId', 'category'],
        computed: {
            ...mapGetters(MUSIC_NAMESPACE, {
                music: MUSIC_GETTER_MUSIC_BY_ID
            }),
            localMusic: {
                get () { return this.music({id: this.musicId, category: this.category}) },
                set (value) {}
            },
            localText: {
                get () { return this.localMusic.musicText },
                set (value) {
                    let payload = {
                        id: this.musicId,
                        category: this.category,
                        key: 'musicText',
                        value: value
                    }
                    this.updateMusicSingleAttribute(payload)
                }
            },
            localPlaceholder: {
                get () {
                    if (this.category === MUSIC_TYPE_CEREMONY_MUSICS || this.category === MUSIC_TYPE_OBSERVANCE_MUSICS) {
                        return i18n.t('ceremony.music.musicPlaceholder')
                    } else if (this.category === MUSIC_TYPE_CEREMONY_BANDS || this.category === MUSIC_TYPE_OBSERVANCE_BANDS) {
                        return i18n.t('ceremony.music.bandPlaceholder')
                    }
                },
                set (value) {}
            }
        },
        methods: {
            ...mapMutations(MUSIC_NAMESPACE, {
                updateMusicSingleAttribute: MUSIC_MUTATION_SINGLE_MUSIC_ATTRIBUTE
            }),
            ...mapActions(MUSIC_NAMESPACE, {
                deleteMusic: MUSIC_ACTION_DELETE_MUSIC,
                updateMusic: MUSIC_ACTION_UPDATE_MUSIC,
                addMusic: MUSIC_ACTION_CREATE_MUSIC
            }),
            leftInput () {
                this.updateMusic(this.localMusic)
            },
            deleteClicked () {
                this.deleteMusic({id: this.localMusic.id, category: this.category})
            },
            addClicked () {
                this.addMusic()
                console.log('add clicked')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .button-div {
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/components/funeral/music/MusicComponent.vue